import UploadedDocumentRow from "./uploaded-document-row";

export default UploadedDocumentRow;
